export const FornulioLoaderIcon = () => {
    const centerX = 57.5;
    const centerY = 57.5;
    const radius = 45;
    const strokeWidth = 12;
    const circumference = 2 * Math.PI * radius;

    return (
        <svg className="fornul-loader" width="115" height="115" viewBox="0 0 115 115" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle
                className="fornul-loader__arc-dark"
                cx={centerX}
                cy={centerY}
                r={radius}
                fill="none"
                stroke="#2C3E50"
                strokeWidth={strokeWidth}
                strokeLinecap="round"
                strokeDasharray={`${circumference} ${circumference}`}
                strokeDashoffset={0}
                transform="rotate(-90 57.5 57.5)"
            />

            <circle
                className="fornul-loader__arc-light"
                cx={centerX}
                cy={centerY}
                r={radius}
                fill="none"
                stroke="#4B99F5"
                strokeWidth={strokeWidth}
                strokeLinecap="round"
                strokeDasharray={`${circumference} ${circumference}`}
                strokeDashoffset={0}
                transform="rotate(-90 57.5 57.5)"
            />
        </svg>
    );
};
